export default __webpack_public_path__ + "static/media/logo.ab170b35.png";